import React, { useState, useMemo } from 'react';
import { connect } from 'react-redux';
import { withStyles, Tooltip, IconButton, Typography } from '@material-ui/core';
import { FindInPage } from '@material-ui/icons';
import { Redirect } from 'react-router-dom';
import { hasPermission, createHistory, hasAtLeastOnePermission } from '../../sc-utilities';
import FilePatternList from './FilePatternList';

const styles = theme => ({
    root: {
        width: `100%`,
        height: 'auto',
        paddingLeft: theme.spacing(-1),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    }
});

const FilePattern = props => {
    const { classes, columns, translations, permissions } = props;

    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, filePatternID: null, redirectPath: '' });
    const redirectHandler = (path, filerPatternID = null) => {
        createHistory();
        setRedirectOptions({ redirect: true, filePatternID: filerPatternID, redirectPath: path })
    };


    let visible = columns && columns['FilePattern'];
    const tableColumns = useMemo(() => {
        return [{
            title: translations["action"] || "Action", field: 'Action',
            hidden: visible ? visible['Action'] : false,
            cellStyle: { minWidth: 100, maxWidth: 100 },
            filtering: false,
            render: rowData => <>
                {
                    hasPermission(permissions, 'file_pattern_load') ? <Tooltip title={translations["file_pattern_details"] || "File pattern details"}>
                        <IconButton
                            id={`edit_file_pattern_${rowData.FilePatternID}`}
                            component='div'
                            onClick={(event) => redirectHandler(`/settings/file-pattern/edit?filePatternID=${rowData.FilePatternID}`)}
                        >
                            <FindInPage />
                        </IconButton>
                    </Tooltip>
                        : null
                }
            </>
        },
        {
            title: translations["name"] || 'Name', field: 'Name',
            hidden: visible ? visible['Name'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Name ? rowData.Name : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["pattern"] || 'Pattern', field: 'Pattern',
            hidden: visible ? visible['Pattern'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Pattern ? rowData.Pattern : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["system"] || 'System', field: 'System',
            hidden: visible ? visible['System'] : false,
            filtering: true,
            lookup: { '1': translations["system"] || 'System', '0': translations["custom"] || 'Custom' },
            defaultFilter: ['0', '1'],
            render: rowData => {
                return <Typography variant={'caption'}>{!rowData.CustomerID ? translations['system'] || 'System' : translations['custom'] || 'Custom'}</Typography>;
            }
        }
        ];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [classes, translations, visible])
    if (!hasAtLeastOnePermission(permissions, ['file_pattern_load'])) {
        tableColumns.shift();
    }
    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'file_pattern_list') ?
                <FilePatternList
                    tableColumns={tableColumns}
                    redirectHandler={redirectHandler}
                />
                :
                null}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || []
    };
};

export default connect(
    mapStateToProps,
    null
)(withStyles(styles)(FilePattern));